// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3336":"608cfb4c","3362":"aa0a8800","8516":"3501e4aa","9899":"98833587"}[chunkId] + ".chunk.css";
};